module.exports = kolibriGlobal.coreVue.mixins.commonCoreStrings;